var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95833 15.0417H5.08646L12.825 7.30312L11.6969 6.175L3.95833 13.9135V15.0417ZM2.375 16.625V13.2604L12.825 2.83021C12.9833 2.68507 13.1582 2.57292 13.3495 2.49375C13.5408 2.41458 13.742 2.375 13.9531 2.375C14.1642 2.375 14.3688 2.41458 14.5667 2.49375C14.7646 2.57292 14.9361 2.69167 15.0813 2.85L16.1698 3.95833C16.3281 4.10347 16.4436 4.275 16.5161 4.47292C16.5887 4.67083 16.625 4.86875 16.625 5.06667C16.625 5.27778 16.5887 5.47899 16.5161 5.67031C16.4436 5.86163 16.3281 6.03646 16.1698 6.19479L5.73958 16.625H2.375ZM12.251 6.74896L11.6969 6.175L12.825 7.30312L12.251 6.74896Z",
    fill: "#1D1B20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/changeIcon.b1bd8f334236245d079228704d32d9a4.svg";
export { ForwardRef as ReactComponent };